<div [@routerTransition]="'fly'">

  <div class="filter-toolbar">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="table-top">
      <ifc-filters-active-list class="layout margin-sm" [filters]="activeFilters" (filterRemoved)="activeFilterRemoved($event)"></ifc-filters-active-list>
      <div fxHide.xs class="layout padding-right-md">
        <button mat-icon-button (click)="filterDialog()" matTooltip="Filter">
          <mat-icon>filter_list</mat-icon>
        </button>
        <button *ngIf="readWriteFailureReason" mat-icon-button routerLink="/admin/failurereason/new" matTooltip="Add">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
      <div fxHide fxShow.xs>
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item (click)="filterDialog()">
            <mat-icon>filter_list</mat-icon>
            <span>Filter</span>
          </button>
          <button mat-menu-item routerLink="/admin/failurereason/new">
            <mat-icon>add_circle</mat-icon>
            <span>Add</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <ifc-app-scroll-container [tabbed]="true">
    <div class="table-container">
      <div class="message-box info" *ngIf="!data.failureReasonQueryResult.totalCount" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
        <mat-icon class="icon">info</mat-icon>
        <span>No data found</span>
      </div>
      <table *ngIf="data.failureReasonQueryResult.totalCount" mat-table matSort [dataSource]="data.failureReasonQueryResult.values" (matSortChange)="sortData($event)">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.name}} </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="code"> Code </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.code}} </td>
        </ng-container>

        <ng-container matColumnDef="externalCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="externalCode"> External code </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.externalCode}} </td>
        </ng-container>

        <ng-container matColumnDef="usage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="usage"> Usage </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{formatUsage(row)}} </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="createdBy"> Created by </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.createdBy}} </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="createdOnUtc"> Created on </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.createdOn | date:'medium'}} </td>
        </ng-container>

        <ng-container matColumnDef="updatedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="updatedBy"> Updated by </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.updatedBy}} </td>
        </ng-container>

        <ng-container matColumnDef="updatedOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="updatedOnUtc"> Updated on </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.updatedOn | date:'medium'}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Status </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}" class="table-cell"> {{row.active ? 'Active' : 'Inactive'}} </td>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="width: 50px;"> </th>
          <td mat-cell *matCellDef="let row" routerLink="/admin/failurereason/{{row.id}}">
            <button mat-icon-button class="action-icon">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns" class="table-header"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;" class="clickable-row"></tr>
      </table>
    </div>
  </ifc-app-scroll-container>

  <div [hidden]="data.failureReasonQueryResult.totalCount <= 10">
    <mat-paginator #paginator showFirstLastButtons [length]="data.failureReasonQueryResult.totalCount"
      [pageSizeOptions]="[10, 20, 50]" (page)="setPage($event)"></mat-paginator>
  </div>

</div>
